import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryDepartments } from "../../domain/repositories/repository-departments";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormCreateDepartment } from "../molecules/form-create-department";
import { FormUpdateDepartment } from "../molecules/form-update-department";

export type ListCommandButtonsDepartmentsProps = Omit<
    ListCommandButtonsProps<RepositoryDepartments>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsDepartments extends React.Component<ListCommandButtonsDepartmentsProps> {
    constructor(props: ListCommandButtonsDepartmentsProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteDepartments(ids: UUID[]): Promise<void> {
        await store.repositoryDepartments.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateDepartment}
                createForm={FormCreateDepartment}
                listState={store.serviceListStates.departments}
                createButtonText={store.i18n.t("page.systemWide.department.createButton.text")}
                createDialogTitle={store.i18n.t("page.systemWide.department.createDialog.title")}
                updateDialogTitle={store.i18n.t("page.systemWide.department.updateDialog.title")}
                {...this.props}
                onDelete={this.deleteDepartments}
            />
        );
    }
}
